/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'upload': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M768 841.143q0-14.848-10.825-25.746t-25.746-10.826-25.747 10.826-10.825 25.746 10.825 25.746 25.747 10.825 25.746-10.825T768 841.143zm146.286 0q0-14.848-10.825-25.746t-25.747-10.826-25.746 10.826-10.825 25.746 10.825 25.746 25.746 10.825 25.747-10.825 10.825-25.746zm73.143-128V896q0 22.82-16.019 38.839t-38.839 16.018H91.43q-22.821 0-38.84-16.018T36.572 896V713.143q0-22.82 16.019-38.839t38.839-16.018h244.004q11.996 32.036 40.302 52.59t63.122 20.553h146.286q34.889 0 63.122-20.554t40.302-52.59H932.57q22.821 0 38.84 16.019t16.018 38.839zM801.719 342.82Q791.99 365.64 768 365.64H621.714v256q0 14.848-10.825 25.746t-25.746 10.826H438.857q-14.848 0-25.746-10.826t-10.825-25.746v-256H256q-23.99 0-33.719-22.82-9.728-22.309 7.973-39.424l256-256Q496.567 36.57 512 36.57t25.746 10.826l256 256q17.7 17.115 7.973 39.424z"/>'
  }
})
